import { useQuery } from '@tanstack/react-query';
import { courierAdminQueries } from '../api/courier-queries';
import type { CourierId } from '../api/courier-api';
import type { CouriersListFilter } from '../lib/filters';

/** Couriers list page (rows + status stats + page count). */
export function useAdminCouriers(filter: CouriersListFilter) {
  return useQuery(courierAdminQueries.list(filter));
}

/** Transport options for the filters modal. */
export function useCourierEquipments(enabled = true) {
  return useQuery(courierAdminQueries.equipments(enabled));
}

/** Bonus templates for the bonus dialog. */
export function useCourierBonuses(enabled = true) {
  return useQuery(courierAdminQueries.bonuses(enabled));
}

/** Foul templates for the foul dialog. */
export function useCourierFouls(enabled = true) {
  return useQuery(courierAdminQueries.fouls(enabled));
}

/** The courier's orders for the foul dialog's order select. */
export function useCourierOrderOptions(courierId: CourierId | undefined, enabled = true) {
  return useQuery(
    courierAdminQueries.orders(courierId ?? '', enabled && courierId !== undefined),
  );
}

/** Latest block record; pass `enabled` once the hint is opened (legacy lazy fetch). */
export function useCourierLatestBlock(
  courierId: CourierId | undefined,
  enabled: boolean,
) {
  return useQuery(
    courierAdminQueries.latestBlock(courierId ?? '', enabled && courierId !== undefined),
  );
}
